export default "__VITE_ASSET__DoUzeQKl__"